<template>
  <body
    class="hold-transition sidebar-mini"
  >
    <div id="layout">
      <div class="wrapper1 zoom_class zoom-moz">
        <!-- <question-menubar /> -->
        <app-content />
        <chat-bot></chat-bot>
      </div>
      <!-- ./wrapper -->
    </div>
  </body>
</template>
<script>
// window.onload = (event) => {
//   var screen_width = window.innerWidth;
//   var per = (screen_width / 1960).toFixed(2);
//   console.log(screen_width);
//   //console.log(per);
//   if (per > 1) {
//     per = 1;
//   }
//   //document.getElementById("app").style.transform = "scale("+per+")";
//   //document.getElementById("app").style.transformOrigin = "0 0";
//   per = per * 100;
//   per = per - 5;
//   var perstring = per + "%";
//   document.getElementById("app").style.zoom = perstring;
//   // $(".zoom_class").css("zoom", per+'% !important');
// };
// document.getElementById("app").style.zoom = per+'% !important';
</script>
<script>
// import QuestionMenubar from "@/views/admin/blocks/QuestionMenubar";
import AppContent from "@/views/admin/blocks/AppContent";
import ChatBot from '../admin/blocks/chat_bot/ChatBot.vue';

export default {
  name: "QuestionLayout",
  components: {
    AppContent,
    ChatBot
    // QuestionMenubar,
  },
  data() {
    return {};
  },
  created() {
    this.setScreenZoomLevel();
  },
  methods: {
    setScreenZoomLevel() {
      let split_route = this.$route.path.split("/");
      console.log(split_route);
      if (split_route[4] == "admin") {
        this.app_id = null;
      } else {
        this.app_id = "zoom_out";
      }
      console.log(split_route);
      var screen_width = window.innerWidth;
      var per = (screen_width / 1960).toFixed(2);
      console.log(screen_width);
      //console.log(per);
      if (per > 1) {
        per = 1;
      }
      //document.getElementById("app").style.transform = "scale("+per+")";
      //document.getElementById("app").style.transformOrigin = "0 0";
      per = per * 100;
      per = per - 5;
      var perstring = per + "%";
      document.getElementById("app").style.zoom = perstring;
    },
  },
};
</script>